interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  dark?: boolean;
}

const sizeMap = {
  sm: { icon: 22, text: 'text-lg' },
  md: { icon: 28, text: 'text-2xl' },
  lg: { icon: 40, text: 'text-4xl' },
};

export function Logo({ size = 'md', dark = false }: LogoProps) {
  const { icon, text } = sizeMap[size];

  return (
    <div className="flex items-center gap-2 select-none">
      {/* Sticker card icon */}
      <svg width={icon} height={icon} viewBox="0 0 32 32" fill="none" aria-hidden>
        {/* Shadow card */}
        <rect x="7" y="5" width="19" height="24" rx="3" fill="#92400e" opacity="0.25" />
        {/* Back card */}
        <rect x="6" y="4" width="19" height="24" rx="3" fill="#fbbf24" />
        {/* Inner photo area */}
        <rect x="8" y="6" width="15" height="16" rx="2" fill="#1e1b4b" opacity="0.85" />
        {/* Player silhouette */}
        <circle cx="15.5" cy="11" r="3" fill="white" opacity="0.9" />
        <path d="M10 20 Q15.5 15 21 20" fill="white" opacity="0.9" />
        {/* Number strip */}
        <rect x="6" y="23" width="19" height="5" rx="2" fill="#f59e0b" />
        <text x="15.5" y="27" textAnchor="middle" fontSize="4" fontWeight="bold" fill="white" fontFamily="Nunito, sans-serif">2026</text>
      </svg>

      <span
        className={`font-display tracking-wide ${text} ${dark ? 'text-night' : 'text-white'}`}
        style={{ fontFamily: '"Fredoka One", cursive' }}
      >
        Barajita
      </span>
    </div>
  );
}
